import { render } from "./AdminAnalytics.vue?vue&type=template&id=52b4d956&scoped=true"
import script from "./AdminAnalytics.vue?vue&type=script&lang=js"
export * from "./AdminAnalytics.vue?vue&type=script&lang=js"

import "./AdminAnalytics.vue?vue&type=style&index=0&id=52b4d956&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52b4d956"]])

export default __exports__